// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"d1b21da4","453":"ffb625b8"}[chunkId] + ".chunk.js";
};